export const SIZE = 10;

export const FIRST_PAGE = 1;

export const LAZY_LOAD_SPACING_THRESHOLD = 400;
